import { Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { CompanyProvider } from './contexts/CompanyContext'
import Layout from './components/layout/Layout'
import ProtectedRoute from './components/common/ProtectedRoute'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import OnboardingForm from './pages/OnboardingForm'
import AdminDashboard from './pages/AdminDashboard'
import AdminReview from './pages/AdminReview'
import Reports from './pages/Reports'
import NotFound from './pages/NotFound'

function App() {
  return (
    <Routes>
      <Route
        path="/:companySlug"
        element={(
          <AuthProvider>
            <CompanyProvider>
              <Outlet />
            </CompanyProvider>
          </AuthProvider>
        )}
      >
        {/* Public routes */}
        <Route path="login" element={<Login />} />
        
        {/* Protected routes */}
        <Route element={<Layout />}>
            <Route element={<ProtectedRoute />}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="onboarding" element={<OnboardingForm />} />
              <Route path="reports" element={<Reports />} />
            </Route>
          
          {/* Admin/HR routes */}
          <Route element={<ProtectedRoute requireAdmin={true} />}>
            <Route path="admin" element={<AdminDashboard />} />
            <Route path="admin/review/:employeeId" element={<AdminReview />} />
          </Route>
        </Route>
      </Route>
      
      {/* Redirect root to login */}
      <Route path="/" element={<Navigate to="/solulever/login" replace />} />
      
      {/* 404 */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default App
